var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spider-chart flex--center--center"},[(_vm.spiderChart)?_c('img',{staticClass:"spider-chart__image",attrs:{"src":_vm.spiderChartUrl,"alt":"spider chart"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }